module.exports = __webpack_public_path__ + "img/MemeETC (9).8c3ca561.jpeg";